// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatContainer {
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.09);
}
.chatContainer .chatList {
  height: 520px;
  overflow-y: auto;
}
.chatContainer .messageContainer {
  height: 500px;
  overflow-y: auto;
  padding: 10px 0;
  position: relative;
}
.chatContainer .dialog {
  position: absolute;
  border-radius: 10px;
  border: 1px solid rgba(160, 162, 179, 0.2);
  background: var(--pure-white-color);
  box-shadow: var(--default-box-shadow);
  width: 650px;
  min-height: 232px;
  max-height: 452px;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  text-align: center;
  margin: auto;
  opacity: 0;
  overflow: auto;
}
.chatContainer .dialog.open {
  opacity: 1;
}
.chatContainer .rce-mbox-photo--download {
  display: unset;
  width: 60px;
  height: 60px;
}`, "",{"version":3,"sources":["webpack://./src/component/common/chat-component/ChatComponent.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;EACA,4EAAA;AACF;AACE;EACE,aAAA;EACA,gBAAA;AACJ;AAEI;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAAN;AAGI;EACE,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,mCAAA;EACA,qCAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AADN;AAII;EACE,UAAA;AAFN;AAKI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAHN","sourcesContent":[".chatContainer {\n  overflow: hidden;\n  border-radius: 20px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.09);\n\n  .chatList {\n    height: 520px;\n    overflow-y: auto;\n  }\n\n    .messageContainer {\n      height: 500px;\n      overflow-y: auto;\n      padding: 10px 0;\n      position: relative;\n    }\n\n    .dialog {\n      position: absolute;\n      border-radius: 10px;\n      border: 1px solid rgba(160, 162, 179, 0.2);\n      background: var(--pure-white-color);\n      box-shadow: var(--default-box-shadow);\n      width: 650px;\n      min-height: 232px;\n      max-height: 452px;\n      top: 50%;\n      left: 0;\n      right: 0;\n      transform: translateY(-50%);\n      text-align: center;\n      margin: auto;\n      opacity: 0;\n      overflow: auto;\n    }\n\n    .dialog.open{\n      opacity: 1;\n    }\n\n    .rce-mbox-photo--download {\n      display: unset;\n      width: 60px;\n      height: 60px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
